/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProvisioningDeviceByDeviceTypeResponse
 */
export interface ProvisioningDeviceByDeviceTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof ProvisioningDeviceByDeviceTypeResponse
     */
    macAddress?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProvisioningDeviceByDeviceTypeResponse
     */
    provisioningDate?: Date;
}

export function ProvisioningDeviceByDeviceTypeResponseFromJSON(json: any): ProvisioningDeviceByDeviceTypeResponse {
    return ProvisioningDeviceByDeviceTypeResponseFromJSONTyped(json, false);
}

export function ProvisioningDeviceByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvisioningDeviceByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'macAddress': !exists(json, 'macAddress') ? undefined : json['macAddress'],
        'provisioningDate': !exists(json, 'provisioningDate') ? undefined : (new Date(json['provisioningDate'])),
    };
}

export function ProvisioningDeviceByDeviceTypeResponseToJSON(value?: ProvisioningDeviceByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'macAddress': value.macAddress,
        'provisioningDate': value.provisioningDate === undefined ? undefined : (value.provisioningDate.toISOString()),
    };
}

